import Admin from "./Admin";
import Login from "./Login";
import AuthVideo from "./auth";
import Videos from "./videos";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useCookies } from "react-cookie";
import Header from "./Header";
export default function App() {
  const [cookies, setCookie] = useCookies(["user"]);

  function handleLogin(user, name) {
    setCookie("user", user, { path: "/" });
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route
            path=":edition/:series/:grade/:title/:subtitle/:chapter/:videoId"
            element={<Videos />}
          />
          <Route
            path=":edition/:series/:grade/:title/:chapter/:videoId"
            element={<Videos />}
          />

          <Route path=":book/:chapter/:videoId" element={<AuthVideo />} />
          {cookies.user?.name ? (
            <Route exact path="/admin" element={<Admin />} />
          ) : (
            <Route
              exact
              path="/admin"
              element={<Login onLogin={handleLogin} />}
            />
          )}
        </Routes>
      </div>
    </BrowserRouter>
  );
}
